module.exports = __webpack_public_path__ + "9a9d3681c08184a05c4ce66e57eb3ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/03_TARA_01.png
// module id = 103
// module chunks = 0